// src/api/optionsApi.js
import axiosInstance from './axiosConfig';

export const optionsApi = {
  // Get all options (public - only shows active items)
  getAllOptions: async () => {
    const response = await axiosInstance.get('/options');
    return response.data;
  },

  // Get categories (public)
  getCategories: async () => {
    const response = await axiosInstance.get('/categories');
    return response.data;
  },

  // Get category tree (public)
  getCategoryTree: async () => {
    const response = await axiosInstance.get('/categories/tree');
    return response.data;
  },

  // Get category by ID (public)
  getCategoryById: async (id) => {
    const response = await axiosInstance.get(`/categories/${id}`);
    return response.data;
  },

  // Get products by category (public)
  getProductsByCategory: async (id, params = {}) => {
    const response = await axiosInstance.get(`/categories/${id}/products`, { params });
    return response.data;
  },

  // Get sizes (public)
  getSizes: async () => {
    const response = await axiosInstance.get('/sizes');
    return response.data;
  },

  // Get colors (public)
  getColors: async () => {
    const response = await axiosInstance.get('/colors');
    return response.data;
  },

  // Get badges (public)
  getBadges: async () => {
    const response = await axiosInstance.get('/badges');
    return response.data;
  },

  // Get vendor options (authenticated vendors)
  getVendorOptions: async () => {
    const response = await axiosInstance.get('/vendor');
    return response.data;
  },
};